import HttpMessage, { ROOT_URL } from './HttpMessage';

class AlertsService {
  static async getAlerts(cityId) {
    const message = {
      route: `${ROOT_URL}/city_alerts?city_id=${cityId}&communication_channel=push`,
      method: 'GET',
      body: null,
      header: null
    };

    return await HttpMessage.sendMessage(message);
  }

  static async getAlert(alertId) {
    const alerts = await this.getAlerts(null);
    if (alerts.status === 'error') {
      return null;
    }

    return alerts.alerts.find((alert) => alert.id == alertId);
  }

  static async getAlertTypes() {
    const message = {
      route: `${ROOT_URL}/city_alerts/types`,
      method: 'GET',
      body: null,
      header: null
    };

    const response = await HttpMessage.sendMessage(message);
    return response.status == 'success' ? response.types : {};
  }
}

export default AlertsService;
